export const STATUS = {
    SUCCESS: 'success',
    ERROR: 'error',
    ALERT: 'alert',
};

export const EVENTS = {
    DISMISS: 'dismiss',
};

export const ICONS = {
    success: 'check-circle-outline',
    error: 'cancel',
    alert: 'error',
};
